import React from 'react'
import { useEffect } from 'react'
import { useState } from 'react'
import axios from "axios"
import Button from '@mui/material/Button';
import Table from "react-bootstrap/Table"
 import "datatables.net-dt/css/dataTables.dataTables.min.css"
import  DataTable from "datatables.net-dt/js/dataTables.dataTables.min.js"
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import {NavLink} from 'react-router-dom'

const DeleteDoctor = () => {
    const[data,setData]=useState([])
   useEffect(()=>{
    axios.get(`https://backendsurgylife-1.onrender.com/doctor`)
    .then((res)=>{
      setData(res.data)
    })
    .catch((err)=>{
      alert("Error Fetching doctor")
    })
    setTimeout(()=>{
            new DataTable ("#yugendraTable")
   
       },1000)
  
  })
  
  const deleteDoctorData =(sid)=>{
    axios.delete(`https://backendsurgylife-1.onrender.com/doctor/${sid}`)
    .then((res)=>{
      alert("Doctor Deleted Successfully")
    })
    .catch((err)=>{
      alert("Error Deleting Doctor")
    })
  }



  return (
   <main>
  

      <section>
        <div className='container'>
          <div className='row'>
            <div className='col-md-12'>
 <Table striped bordered hover id='yugendraTable'>
      <thead>
        <tr>
          <th>T.Name</th>
          <th>D.Name</th>
          <th>D.Experience</th>
           <th>D.Qualification</th>
          <th>W.Hospital.W</th>
          <th>Location</th>
          <th>D.Phone</th>
          <th>Actions</th>

        </tr>
      </thead>

      <tbody>
         {
          data.map((doctor)=>{
          return(
            <tr key={doctor._id}>
              <td>{doctor.trtname}</td>
              <td>{doctor.dname}</td>
              <td>{doctor.dexperience}</td>
              <td>{doctor.dqualification}</td>
              <td>{doctor.whospitalw}</td>
              <td>{doctor.location}</td>
              <td>{doctor.dphone}</td>


          
                <td className='d-flex  justify-content-center  '>
      <Button variant="contained" color='error' className='me-3' onClick={()=>{deleteDoctorData(doctor._id)}}>
        <DeleteIcon/>
      </Button>


      <Button 
                       variant="outlined"
                        color='success'
                       >
                        <NavLink to={`/editdoctor/${doctor._id}`}>
                                <EditIcon/>
                        </NavLink>
               
                          </Button>

                </td>
            </tr>
          )
          })
         }
          </tbody>
    </Table>
            </div>
          </div>
        </div>
      </section>

    </main>  )
}

export default DeleteDoctor
